import { render } from "./resolution-text-truncated-display.vue?vue&type=template&id=1f4851e5"
import script from "./resolution-text-truncated-display.vue?vue&type=script&lang=js"
export * from "./resolution-text-truncated-display.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__